export const fixedAndFloat = (value: number, precision?: number) => parseFloat(value.toFixed(precision || 2));
